import { filterTokens } from './filter-tokens';
import type { TokenGroup } from './grouped-tokens';

export const filterGroups: (
	groups: TokenGroup[],
	filters: {
		showStates?: string[];
	},
) => TokenGroup[] = (
	groups: TokenGroup[],
	filters: {
		showStates?: string[];
	},
): TokenGroup[] =>
	groups.reduce((newGroups: TokenGroup[], currentGroup) => {
		const newGroup = {
			...currentGroup,
			tokens: filterTokens(currentGroup.tokens, filters),
			subgroups: currentGroup.subgroups?.reduce((newSubgroups: TokenGroup[], currentSubgroup) => {
				const newSubgroup = {
					...currentSubgroup,
					tokens: filterTokens(currentSubgroup.tokens, filters),
				};

				if (newSubgroup.tokens.length > 0) {
					newSubgroups.push(newSubgroup);
				}

				return newSubgroups;
			}, []),
		};

		if (newGroup.tokens.length > 0 || (newGroup?.subgroups && newGroup.subgroups.length > 0)) {
			newGroups.push(newGroup);
		}

		return newGroups;
	}, []);
